import { ClassificacaoRisco, TipoServico } from 'graphql/types.generated'
import { metaPath } from 'util/metaPath'

import { AntropometriaAccordionModel } from '../components/MedicoesPanel/AntropometriaAccordion'
import { SinaisVitaisAccordionModel } from '../components/MedicoesPanel/SinaisVitaisAccordion'
import { AgendarConsultaPanelModel } from '../detail/soap/finalizacao/components/agendar-consulta/AgendarConsultaPanel'
import {
  DesfechoAtendimentoFormModel,
  ManterCidadaoLista,
} from '../detail/soap/finalizacao/components/DesfechoAtendimentoPanel'
import { ProcedimentoSigtapFieldModel } from '../detail/soap/finalizacao/components/ProcedimentoSigtapField'
import { MotivoConsultaFormModel } from './motivo-consulta/MotivoConsultaForm'

export type TiposServicoEscutaInicial = Partial<TipoServico>

export interface ProcedimentosEscutaInicial {
  procedimentosSigtap?: ProcedimentoSigtapFieldModel[]
  codigosProcedimentosAutomaticosExcluidos?: string[]
}

export interface EscutaInicialState {
  lastSaved?: Date
  motivoConsulta?: MotivoConsultaFormModel
  openedAccordions?: (string | number)[]
  sinaisVitais?: SinaisVitaisAccordionModel
  antropometria?: AntropometriaAccordionModel
  desfecho?: DesfechoAtendimentoFormModel
  procedimentos?: ProcedimentosEscutaInicial
  procedimentosAdministrativos?: ProcedimentoSigtapFieldModel[]
  classificacaoRisco?: ClassificacaoRisco
  agendamentoConsulta?: AgendarConsultaPanelModel
  imprimirEscutaInicial?: boolean
}

export const name = metaPath<EscutaInicialState>()

export const initialValue = (
  tiposServico: ReadonlyArray<TiposServicoEscutaInicial>,
  canCreateNovoAtendimento: boolean
): Partial<EscutaInicialState> => ({
  sinaisVitais: {
    openedAccordions: ['sinaisVitais'],
  },
  antropometria: {
    openedAccordions: ['antropometria'],
  },
  openedAccordions: ['D'],
  lastSaved: new Date(),
  desfecho: {
    manterCidadaoLista: canCreateNovoAtendimento ? ManterCidadaoLista.SIM : ManterCidadaoLista.NAO,
    atendimento: { tiposServico: tiposServico?.map((t) => t.id) },
  },
})
